<template>
  <div class="col-md-6 col-sm-12 col-xs-12 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar un nuevo documento</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <el-upload
                  ref="upload"
                  v-validate="modelValidations.document"
                  :auto-upload="false"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  class="upload-demo"
                  name="document"
                >
                  <base-button slot="trigger" type="success">Subir archivo</base-button>
                  <div slot="tip" class="el-upload__tip mt-2 pl-1">Solo archivos pdf</div>
                </el-upload>

                <div v-for="err in fileErrors" :key="err.msg">
                  <small class="text-danger">{{ err.msg }}</small>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Tipo de documento (*) </label>

                <el-select
                  ref="documentType"
                  v-model="formData.documentType"
                  v-validate="modelValidations.documentType"
                  autocomplete="off"
                  name="documentType"
                  placeholder="Tipo de documento"
                >
                  <el-option
                    v-for="option in documentTypesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>

                <small v-show="documentType.invalid" class="text-danger">
                  {{ getError('documentType') }}
                </small>
              </div>
            </div>
          </div>

          <div v-if="generic" class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Para quién? (*)</label>

                <el-select
                  v-model="formData.entityType"
                  v-validate="modelValidations.entityType"
                  autocomplete="off"
                  filterable
                  name="entityType"
                  placeholder="Para quién?"
                  @change="formData.entity = null"
                >
                  <el-option
                    v-for="option in entityTypesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option"
                  />
                </el-select>

                <small v-show="entityType.invalid" class="text-danger">
                  {{ getError('entityType') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div v-if="formData.entityType !== null" class="form-group">
                <label class="control-label d-block">Seleccione {{ formData.entityType.label }}</label>

                <el-autocomplete
                  v-model="formData.selectedEntity"
                  v-validate="modelValidations.entity"
                  name="entity"
                  :fetch-suggestions="querySearchAsync"
                  :placeholder="formData.entityType.label"
                  :debounce="500"
                  @select="handleSelect"
                ></el-autocomplete>

                <small v-show="searchError !== ''" class="text-danger d-block">
                  {{ searchError }}
                </small>

                <small v-show="entity.invalid" class="text-danger d-block">
                  {{ getError('entity') }}
                </small>
              </div>
            </div>
          </div>

          <div v-if="false && receiptTypes.length > 0" class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Comprobante</label>

                <el-select
                  v-model="formData.receiptTypeId"
                  v-validate="'required_if:documentType,Cuenta Corriente'"
                  autocomplete="off"
                  name="receiptTypeId"
                  placeholder="Comprobante"
                >
                  <el-option v-for="option in receiptTypes" :key="option.id" :label="option.label" :value="option.id" />
                </el-select>

                <small v-show="receiptTypeId.invalid" class="text-danger">
                  {{ getError('receiptTypeId') }}
                </small>
              </div>
            </div>
          </div>

          <div v-if="false && receiptTypes.length > 0" class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Asociar a Pedido</label>

                <el-select
                  v-model="formData.orderId"
                  v-validate="'required_if:documentType,Cuenta Corriente'"
                  autocomplete="off"
                  filterable
                  name="orderId"
                  placeholder="Número de Pedido"
                >
                  <el-option v-for="option in orders" :key="option.id" :label="option.code" :value="option.id" />
                </el-select>

                <small v-show="orderId.invalid" class="text-danger">
                  {{ getError('orderId') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Descripción </label>

                <el-input
                  v-model="formData.description"
                  :rows="4"
                  name="description"
                  placeholder="Descripción"
                  type="textarea"
                >
                </el-input>

                <small v-show="description.invalid" class="text-danger">
                  {{ getError('description') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Nombre del documento </label>

                <el-input
                  v-model="formData.documentName"
                  v-validate="modelValidations.documentName"
                  name="documentName"
                  placeholder="Nombre del documento"
                  type="text"
                >
                </el-input>

                <small v-show="documentName.invalid" class="text-danger">
                  {{ getError('documentName') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Autocomplete, Select, Option, Upload } from 'element-ui';
import { mapFields } from 'vee-validate';
import RemoteAutocompleteMixin from '../../../mixins/remoteAutocompleteMixin';
const CHECKING_ACCOUNT = 'Cuenta Corriente';

export default {
  components: {
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Autocomplete.name]: Autocomplete,
    [Option.name]: Option,
  },

  mixins: [RemoteAutocompleteMixin],
  props: {
    generic: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      documentTypes: [],
      entityTypes: [],
      producers: [],
      distributors: [],
      validated: false,
      fileErrors: [],
      receiptTypes: [],
      orders: [],
      formData: {
        documentType: null,
        documentName: '',
        description: '',
        document: null,
        entityType: null,
        entity: null,
        selectedEntity: null,
        receiptTypeId: null,
        orderId: null,
      },

      modelValidations: {
        documentType: {
          required: true,
        },

        documentName: {
          regex: /^([-a-z0-9_ ])+$/i,
        },

        entityType: {
          required: true,
        },

        entity: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['documentType', 'description', 'entity', 'entityType', 'documentName', 'receiptTypeId', 'orderId']),
    documentTypesOptions() {
      return this.documentTypes;
    },

    entityTypesOptions() {
      return this.entityTypes;
    },
  },

  watch: {
    'formData.entity': {
      handler() {
        if (this.formData.documentType === CHECKING_ACCOUNT && this.formData.entity) {
          this.fetchReceiptTypes();
          this.fetchOrders();
        }
      },
    },
  },

  created() {
    this.fetchDocumentTypes();
    this.fetchEntityTypes();
  },

  methods: {
    fetchDocumentTypes() {
      this.documentTypes = [
        {
          label: 'Stock',
          value: 'Stock',
        },
        {
          label: CHECKING_ACCOUNT,
          value: CHECKING_ACCOUNT,
        },
        {
          label: 'Liquidación',
          value: 'Liquidación',
        },
      ];
    },

    fetchEntityTypes() {
      this.entityTypes = [
        {
          value: 'producers',
          label: 'Productor',
        },
        {
          value: 'distributors',
          label: 'Distribuidor',
        },
      ];
    },

    fetchReceiptTypes() {
      this.$services
        .resource('document_receipt_types')
        .get()
        .then((res) => {
          this.receiptTypes = res.data.data.documentReceiptTypes;
        });
    },

    fetchOrders() {
      const filterName = this.formData.entityType.value === 'distributors' ? 'filter[distributor]' : 'filter[producer]';
      const params = { [filterName]: this.formData.entity.id };

      this.$services
        .resource('orders')
        .get(params)
        .then((res) => {
          this.orders = res.data.data.orders;
        });
    },

    fetchData(query) {
      if (this.formData.entityType.value === 'producers') {
        return this.fetchProducers(query);
      } else if (this.formData.entityType.value === 'distributors') {
        return this.fetchDistributors(query);
      }
    },

    selectOptions() {
      return this.formData.entityType.value === 'producers' ? this.producers : this.distributors;
    },

    fetchProducers(query) {
      this.producers = [];
      return this.$services
        .resource('producers')
        .search({ query })
        .then((res) => res.data.data)
        .then((producers) => {
          this.checkResults(producers);
          this.producers = producers;
        });
    },

    fetchDistributors(query) {
      this.distributors = [];
      return this.$services
        .resource('distributors')
        .search({ query })
        .then((res) => res.data.data)
        .then((distributors) => {
          this.checkResults(distributors);
          this.distributors = distributors;
        });
    },

    beforeUpload() {
      return new Promise((resolve, reject) => {
        this.fileErrors = [];

        if (this.$refs.upload.uploadFiles.length > 1) {
          this.fileErrors.push({
            msg: 'Solo puede cargar un archivo!',
          });
          return reject(false);
        }

        if (this.$refs.upload.uploadFiles[0]) {
          const file = this.$refs.upload.uploadFiles[0].raw;

          const isPDF = file.type === 'application/pdf';
          const isLt2M = file.size / 1024 / 1024 < 10;

          if (!isPDF) {
            this.fileErrors.push({
              msg: 'El archivo debe estar en formato PDF!',
            });
            return reject(false);
          }
          if (!isLt2M) {
            this.fileErrors.push({
              msg: 'El archivo excede los 10MB!',
            });
            return reject(false);
          }
          return resolve(true);
        }
        this.fileErrors.push({
          msg: 'El documento es obligatorio',
        });
        return reject(false);
      });
    },

    async firstFormSubmit() {
      try {
        return await Promise.all([this.$validator.validateAll(), this.beforeUpload()]);
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit()
        .then((res) => {
          if (res.every((validation) => validation)) {
            this.formData.document = this.$refs.upload.uploadFiles.pop().raw;
            this.$emit('save', this.formData);
          }
        })
        .catch((e) => {});
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>
